"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var AddressCorrection = _ref => {
  var {
    data,
    submit,
    cancel
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "mm-spacing--none"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Street: "), data.street), /*#__PURE__*/_react.default.createElement("p", {
    className: "mm-spacing--none"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "City: "), data.city), /*#__PURE__*/_react.default.createElement("p", {
    className: "mm-spacing--none"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "State: "), data.state), /*#__PURE__*/_react.default.createElement("p", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Zip: "), data.zip), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    onClick: submit
  }, "Use This Address"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    onClick: cancel,
    variant: "secondary"
  }, "Don't Use This Address"));
};
var _default = exports.default = AddressCorrection;